import { render, staticRenderFns } from "./LoginTypeSelection.vue?vue&type=template&id=2fa29544&"
import script from "./LoginTypeSelection.vue?vue&type=script&lang=js&"
export * from "./LoginTypeSelection.vue?vue&type=script&lang=js&"
import style0 from "./LoginTypeSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports